import { DisplayElementModel } from './display-element.model';
import { TextStyleModel } from './text-style.model';

const emptyLinesAndHTMLElements = /(\n)|(<(div|p|span|ul|ol)[^>]*>(\s|&nbsp;|<\/?\s?br\s?\/?>)*<\/?(div|p|span|ul|ol)>)/g;

export class TextDisplayElementModel extends DisplayElementModel {
    declare styles: TextStyleModel;
    text: string;
    editorDirty: boolean;
    htmlEdit: boolean = false;

    constructor(
        content?: string,
        styles?: any
    ) {
        super();

        this.text = content;
        this.styles = new TextStyleModel(styles);
        this.isBoundToGlobalStyles = true;
    }

    canRender(): boolean {
        if (!this.text) {
            return false;
        }

        return !!this.text.replace(emptyLinesAndHTMLElements, '');
    }

    clone(): TextDisplayElementModel {
        // Hack for alerts, somewhere in alerts it's not a class
        const clone = new TextDisplayElementModel(this.text, this.styles && this.styles.clone ? this.styles.clone() : JSON.parse(JSON.stringify(this.styles)));
        clone.displayType = this.displayType;

        return clone;
    }


    onUpdate(): boolean {
        return false;
    }

    isEqual(other: TextDisplayElementModel): boolean {
        if (!other) {
            return false;
        }
        if (this.text !== other.text) {
            return false;
        }
        if (!this.styles.equals(other.styles, true)) {
            return false;
        }
        if (this.isBoundToGlobalStyles !== other.isBoundToGlobalStyles) {
            return false;
        }
        if (this.htmlEdit !== other.htmlEdit) {
            return false;
        }

        return true;
    }
}
